export const RoutesNames = {
  Analytics: '/analytics',
  Profile: '/profile',
  Properties: '/properties',
  ResidentDetails: '/residents/:id',
  ApplicantDetails: '/applicants/:id',
  Residents: '/residents',
  Applicants: '/applicants',
  PropertyManagers: '/property-managers',
  PropertyManager: '/property-managers/:id',
  Payment: '/settings',
  Integrations: '/integration-settings',
  PropertyIntegration: '/integration-settings/:type/:id',
  Resman: '/resman',
  Yardi: '/yardi',
  Entrata: '/entrata',
  PartnerApi: '/partner-api',
  RealPage: '/real-page',
  AppFolio: '/appfolio',
  Support: '/support',
  FAQ: '/faq',
  Animals: '/animals',
  AnimalCurrentDetails: '/animals/current/:id',
  AnimalMovedOutDetails: '/animals/moved-out/:id',
  AnimalApplicantDetails: '/animals/applicant/:id',
  AnimalsVisitationDetails: '/animals/visitation/:id',
  AnimalsAll: '/animals/all',
  AnimalsCurrent: '/animals/current',
  AnimalsMovedOut: '/animals/moved-out',
  AnimalsApplicant: '/animals/applicant',
  AnimalsVisitation: '/animals/visitation',
  Policies: '/policies',
  IndividualProperty: '/properties/:id/:tabName?',
  Documents: '/documents',
  SuggestedTexts: '/suggested-texts',
  Dashboard: '/dashboard',
  Curriculum: '/curriculum',
  SubCurriculum: '/curriculum/:curriculumId',
  CurriculumDetail: '/curriculum/:curriculumId/:id',
  ResetPassword: '/reset-password',
  SignUp: '/sign-up',
  SignIn: '/sign-in',
  Impersonation: '/impersonation-pm',
  Confirmation: '/confirmation',
  Certificate: '/certificate/:courseId/:checkpointKey',
  Complaints: '/complaints',
  Complaint: '/complaints/complaint',
  Notice: '/complaints/notice',
  ComplaintDetails: '/complaints/complaint/:id',
  NoticeDetails: '/complaints/notice/:id',
  AllRoommates: '/roommates/:tenantResidencyId',
  Lease: '/lease',
  LeaseDetails: '/lease/:tenantResidencyId',
  RedirectComplaint: '/redirect/complaint',
  RedirectNotice: '/redirect/notice',
  Notifications: '/notifications/:id',
  AccountSettings: '/account-settings',
  Authentication: '/authentication-settings',
  AzureSsoConfigure: '/authentication-settings/azure/configure',
  ScimSettings: '/scim-settings',
  ScimGroups: '/scim-settings/groups',
  SocialAuth: '/social-auth',
  PropertyConfigs: '/properties-configs',
  SignUpAccessCodes: '/properties-sign-up-access-codes',
  Reporting: '/reporting',
  PropertyReportConfig: '/reporting/:propertyId',
};
export const TabValues = {
  [RoutesNames.Analytics]: 'analytics',
  [RoutesNames.Profile]: 'profile',
  [RoutesNames.Properties]: 'properties',
  [RoutesNames.PropertyManagers]: 'maintainers',
  [RoutesNames.PropertyManager]: 'property-managers',
  [RoutesNames.Integrations]: 'settings',
  [RoutesNames.Payment]: 'settings',
  [RoutesNames.PropertyIntegration]: 'settings',
  [RoutesNames.Support]: 'support',
  [RoutesNames.Animals]: 'animals',
  [RoutesNames.AnimalCurrentDetails]: 'animals',
  [RoutesNames.AnimalMovedOutDetails]: 'animals',
  [RoutesNames.AnimalsApplicant]: 'animals',
  [RoutesNames.AnimalsMovedOut]: 'animals',
  [RoutesNames.AnimalsCurrent]: 'animals',
  [RoutesNames.AnimalsVisitation]: 'animals',
  [RoutesNames.Residents]: 'residents',
  [RoutesNames.ResidentDetails]: 'residents',
  [RoutesNames.ApplicantDetails]: 'residents',
  [RoutesNames.Policies]: 'policies',
  [RoutesNames.IndividualProperty]: 'properties',
  [RoutesNames.Documents]: 'documents',
  [RoutesNames.SuggestedTexts]: 'suggested-texts',
  [RoutesNames.Dashboard]: 'dashboard',
  [RoutesNames.Curriculum]: 'curriculum',
  [RoutesNames.CurriculumDetail]: 'curriculum',
  [RoutesNames.StatePolicy]: 'state-policy',
  [RoutesNames.ResetPassword]: 'reset-password',
  [RoutesNames.SignUp]: 'sign-up',
  [RoutesNames.Confirmation]: 'confirmation',
  [RoutesNames.Certificate]: 'certificate',
  [RoutesNames.Complaints]: 'complaints',
  [RoutesNames.Complaint]: 'complaints',
  [RoutesNames.Notice]: 'complaints',
  [RoutesNames.NoticeDetails]: 'complaints',
  [RoutesNames.ComplaintDetails]: 'complaints',
  [RoutesNames.AllRoommates]: 'roommates',
  [RoutesNames.LeaseDetails]: 'lease',
  [RoutesNames.Notifications]: 'notifications',
  [RoutesNames.AccountSettings]: 'account-settings',
  [RoutesNames.Reporting]: 'reporting',
  [RoutesNames.Authentication]: 'settings',
  [RoutesNames.AzureSsoConfigure]: 'settings',
  [RoutesNames.ScimSettings]: 'settings',
  [RoutesNames.ScimGroups]: 'settings',
};
